module.exports = __webpack_public_path__ + "static/media/mtto_maquinas.f764ff62.svg";